<template>
    <div class='contents' >
        <!-- Store Tab List -->
        <MainTabContainer
            ref="mainTab"
            v-if='multiStoreType'
            :tabList='stores'
            :currentCode='currentStoreCode'
            :categoryIndex.sync="categoryIndex"
            :methodForTab='(code) => { markSelectTab(code) }'/>
        <!-- Category Tab List -->
        <MainTabContainer
            ref="mainTab"
            v-if='!multiStoreType'
            :tabList='getCategories'
            :currentCode='currentCategoryCode'
            :categoryIndex.sync="categoryIndex"
            :methodForTab='(code) => markSelectTab(code)'/>
        <ul
          class="goodsUl"
          v-for='(category, index) in getCategories'
          :key='index'
          :ref="category.code"
          :data-code="category.code"
          :data-index="index"
          ref-in-for
        >
          <div class="categoryInfo">
          <strong class="title">{{ category?.name }}</strong>
            <p>{{ category?.desc }}</p>
          </div>
            <template v-if="menuByCategories && menuByCategories[category.code]">
              <MenuItem
                v-for="(menu, index) in menuByCategories[category.code]"
                :key="index"
                class="goodsList li"
                :menu="menu"
              />
            </template>
            <template v-else>
              <div class='noData categoryNodata'>
                <div class='in'><p>{{ NO_MORE_MENU_MSG }}</p></div>
              </div>
            </template>
        </ul>
        <div class='li notice'>{{$t('menuDesc')}}</div>
        <div class="originType1" v-if="this.companyType != 4" :class="{hidden: !this.stores[this.currentStoreCode].originDesc}">
          <div class="originWrap" @click="originBtn()" v-if="originFlag">
            <div class="originTop">
              <div>{{$t('originOfIngredients')}}</div>
              <div class="originOpenBtn"></div>
            </div>
          </div>
          <div class="originWrap" @click="originBtn()" v-else>
            <div class="originTop">
              <div>{{$t('originOfIngredients')}}</div>
              <div class="originCloseBtn"></div>
            </div>
            <div class="originContent">
              <p>{{this.stores[this.currentStoreCode].originDesc}}</p>
            </div>
          </div>
        </div>
        <!-- <div class="originType2" v-else >
          <div class="originPopup" :class="{disabled: !this.stores[this.currentStoreCode].originDesc}" @click="originPopup()">원산지보기</div>
        </div> -->
        <OriginPopUp/>
        <AppCompanyInfo/>
    </div>
</template>
<script lang="js">
import MainTabContainer from '@/components/MainPage/MainTabContainer.vue'
import MenuItem from '@/components/Common/MenuItem.vue'
import OriginPopUp from '@/components/PopUp/OriginPopUp.vue'
import AppCompanyInfo from '@/components/App/AppCompanyInfo.vue'
import Vue from 'vue'
import { MAIN_MENU_CONTAINER } from '@/utils/EndPoint'
import { REQ_MENU_LIST, REQ_CATEGORY_LIST, SET_OPERATING_STATE, SET_CATEGORY_CODE } from '@/store/_actions/actionTypes'
import { NETWORK_ERROR_MESSAGE, NO_MORE_MENU_MSG } from '@/utils/Message'
import throttle from 'lodash/throttle'
export default Vue.extend({
  name: MAIN_MENU_CONTAINER,
  props: ['pageEndFlag', 'companyType'],
  components: { MainTabContainer, MenuItem, AppCompanyInfo, OriginPopUp },
  data () {
    return {
      NO_MORE_MENU_MSG,
      pageNumber: 2,
      menuType: ['세트', '단품'],
      lastPageFlag: this.pageEndFlag,
      categoryIndex: 0,
      originFlag: true,
      categoryDoms: [],
      scrollEvent: null,
      useMoveCategory: false
    }
  },
  computed: {
    fullVUi () { return this.$store.getters.fullVUi },
    multiStoreType () { return this.$store.getters.multiStoreType },
    stores () { return this.$store.getters.stores },
    getCategories () { return this.$store.getters.categories },
    menus () { return this.$store.getters.menus },
    currentStoreCode () { return this.$store.getters.currentStoreCode },
    currentCategoryCode () { return this.$store.getters.currentCategoryCode },
    menuByCategories () { return this.$store.getters.menuByCategories }
  },
  watch: {
    pageEndFlag () { this.lastPageFlag = this.pageEndFlag }
  },
  mounted () {
    // 아래 코드 주석하면 카테고리 헤더 항상 활성화
    this.setScrollEventOfTab()
    this.categoryDoms = []
    this.$nextTick(() => {
      this.getCategories.forEach(category => {
        const categoryDom = this.$refs[category.code][0]
        if (categoryDom) this.categoryDoms.push(categoryDom)
      })
    })
    this.addScrollEvent()
  },
  methods: {
    originPopup () {
      this.createPopUp('#origin.cusLayer')
    },
    originBtn () {
      this.originFlag = !this.originFlag
    },
    methodThen (response, state) { // category, menu list 요청 then'
      this.moveToOnTab()
      if (response.pageEndFlag === true) {
        this.lastPageFlag = false
        if (state) state.complete()
        else window.scrollTo(0, 0)
        this.lastPageFlag = true
      } else {
        this.pageNumber++
        if (state) state.loaded()
        else window.scrollTo(0, 0)
        this.lastPageFlag = false
      }
    },
    methodCatch () { // category, menu list 요청 catch
      this.toast(this, NETWORK_ERROR_MESSAGE)
    },
    reqNextPage ($state) { this.requestMenuList(this.currentCategoryCode, $state) },
    // 상품 리스트 요청
    requestMenuList (categoryCode, state) {
      const requestData = {
        categoryCode: categoryCode,
        pageNumber: this.pageNumber
      }
      this.lastPageFlag = true
      this.$store.dispatch(REQ_MENU_LIST, requestData)
        .then((response) => {
          this.methodThen(response, state)
          this.$store.commit(SET_OPERATING_STATE, response) // 카테고리 판매 불가 상태 설정
        })
        .catch(this.methodCatch)
    },
    // 카테고리 리스트 요청
    requestCategoryList (storeCode) {
      this.$store.dispatch(REQ_CATEGORY_LIST, storeCode)
        .then(this.methodThen)
        .catch(this.methodCatch)
    },
    async markSelectTab (code) {
      console.log('## markSelectTab')
      this.useMoveCategory = true
      const el = this.$refs[code]
      if (el && el[0]) {
        const firstDom = el[0]
        await firstDom.scrollIntoView({ behavior: 'smooth', block: 'start' })
        this.$store.commit(SET_CATEGORY_CODE, code)
        this.activeScrollEvent()
      }
    },
    // 스크롤 이벤트 다시 활성화
    async activeScrollEvent () {
      const waitScrollEnd = () => {
        return new Promise(resolve => {
          let timeout
          const onScroll = () => {
            clearTimeout(timeout)
            timeout = setTimeout(() => {
              this.useMoveCategory = false
              window.removeEventListener('scroll', onScroll)
              resolve()
            }, 100)
          }
          window.addEventListener('scroll', onScroll, { passive: true })
          // 최초 호출용
          onScroll()
        })
      }
      await waitScrollEnd()
    },
    addScrollEvent () {
      const checkScorllY = () => {
        // 카테고리 헤더로 이동하는 중에는 이벤트 비활성화
        if (!this.useMoveCategory) {
          let crossing = null
          let crossingTop = Infinity
          // 상점 헤더, 카테고리 헤더 대략 상단 px
          const lineY = 108

          this.categoryDoms.forEach(el => {
            const r = el.getBoundingClientRect()
            // 선택된 상품 영역의 상단이 108px 이하 이고 상품 영역 하단이 108 이상인 경우
            // 카테고리 영역과 상품 영역이 겹쳤다고 판단하고 카테고리 색상 변경
            if (r.top <= lineY && r.bottom >= lineY) {
              if (r.top < crossingTop) { crossing = el; crossingTop = r.top }
            }
          })
          if (crossing) {
            const code = crossing.getAttribute('data-code')// 카테고리 code
            const index = crossing.getAttribute('data-index') // 카테고리 배열의 인덱스
            console.log('categoryCode:', code, 'index:', index)

            // 해당하는 카테고리 색상 변경
            this.$store.commit(SET_CATEGORY_CODE, code)
            this.categoryIndex = index
          }
        }
      }
      this.scrollEvent = throttle(checkScorllY, 100)
      window.addEventListener('scroll', this.scrollEvent, { passive: true })
    }
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.scrollEvent)
  }
})
</script>

<style scoped>
  #footer {
    margin-bottom: 0vw;
  }

  .ul.hori-list {
  display: flex;
  gap: 8px;                 /* 필요시 간격 */
  overflow-x: auto;         /* 가로 스크롤 */
  scroll-snap-type: x mandatory;
  scroll-padding-left: 48px;/* ← 활성 항목을 좌측 48px에 놓음 */
  scroll-behavior: smooth;  /* 부드럽게 */
  -webkit-overflow-scrolling: touch;
  overflow-x: auto;            /* 스크롤은 유지 */
  -ms-overflow-style: none;    /* IE/Edge(레거시) */
  scrollbar-width: none;       /* Firefox */
}

.ul.hori-list::-webkit-scrollbar {
  display: none;               /* Chrome/Safari/Edge(Chromium) */
}
.ul.hori-list .mm {
  flex: 0 0 auto;           /* 줄바꿈/축소 방지 */
  scroll-snap-align: start; /* 스냅 기준 */
  scroll-snap-stop: always; /* 스냅 포인트에서 멈추도록 */
}

.contents .goodsUl {
  scroll-margin-top: 102px; /* 고정 헤더 높이에 맞춰 값만 수정 */
}

/* on 상태(또는 :target) 스타일 */
.ul.hori-list .mm.on a,
.ul.hori-list .mm:target a {
  font-weight: 700;
  /* 기타 강조 스타일 */
}

.regiCateNaviBox{
    top:50px;
}

.navi-arrow{
  top: 50%;
  transform: translate3d(0, -50%, 0); /* GPU 합성 + 정중앙 고정 */
  will-change: transform;              /* 스크롤 중 안전하게 */
  backface-visibility: hidden;
}
.goodsUl {
  border-bottom: 8px solid #f5f5f5;
  .goodsList {
    border-bottom: 0;
  }
}

.categoryInfo {
  padding: 10px 16px;
  line-height: 24px;
  color: #0d0d0d;
  word-break: break-all;
  border-bottom: 1px solid #e6e6e6;
  .title {
    display: block;
    margin-bottom: 2px;
    font-size: 18px;
    font-weight: 700;
  }
  p {
    font-size: 16px;
  }
}
</style>
